export class Constants {
    public static readonly HIDDEN_COLUMN_CLASSES = 'd-none d-md-block'
}